import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 所属病院一覧
 *
 * 自分が所属している病院の一覧を返す
 */
export class FetchHospital implements APIRequest<Monitaro.FetchHospitalResponse> {
  response: Monitaro.FetchHospitalResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/hospitals`
  }
}

/**
 * 検索可能な病院一覧
 *
 * 検索可能な病院一覧を返す
 */
export class SelectableHospital implements APIRequest<Monitaro.SelectableHospitalResponse> {
  response: Monitaro.SelectableHospitalResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/hospitals/selectable`
  }
}

/**
 * 所属病院の表示
 *
 * 指定されたIDの病院情報を返す。
 */
export class GetHospital implements APIRequest<Monitaro.GetHospitalResponse> {
  response: Monitaro.GetHospitalResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(hospital: string) {
    this.path = `/hospitals/${hospital}`
  }
}

/**
 * プライマリ病院の変更
 *
 * 所属している病院からプライマリ病院を変更する
 */
export class PutHospital implements APIRequest<Monitaro.PutHospitalResponse> {
  response: Monitaro.PutHospitalResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PUT
  constructor(hospital: string) {
    this.path = `/hospitals/${hospital}`
  }
}
